export default __webpack_public_path__ + "static/media/Chain of Tartaros.ef78ee53.jpg";